<template>
    <div class="bg-white shadow p-24 rounded border trans-ease border-white">
        <h2 class="font-semibold text-body mb-4 first-letter:uppercase">
            {{ $t('campaigns.characteristics') }}
        </h2>
        <div v-for="(char, i) in characteristics"
             :class="i !== characteristics.length - 1 ? 'border-b-2 border-primary-5 py-16' : ' pt-16'">
            <div class="flex justify-between items-center h-24">
                <p>{{ char.title }}</p>
                <loading v-if="!char.items" size="small"/>
                <div class="flex" v-else>
                    <div v-for="item in char.items" :key="item.id"
                         class="flex-none bg-primary-5 font-semibold h-24 rounded-6 mr-8 my-4 cursor-default shadow-sm">
                        <span class="px-8">{{ char.translatable ? $t(char.translatable + item.name) : item.name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from "./ui/Loading";
import Campaign from "../models/Campaign";
import * as campaigns from "../services/CampaignService";
import _upperFirst from 'lodash/upperFirst';

export default {
    components: {Loading},
    props: {
        campaign: Campaign
    },
    data() {
        return {
            educations: null,
            regions: null,
            profiles: null,
            sectors: null,
            levels: null,
        }
    },
    computed: {
        characteristics() {
            const country_code = this.campaign && this.campaign.country_code ? this.campaign.country_code : null;

            return [
                {
                    title: _upperFirst(this.$t('campaigns.educations')),
                    items: this.educations,
                    translatable: 'campaigns.editor.educations' + (country_code ? '.' + country_code : '') + '.'
                },
                {
                    title: _upperFirst(this.$t('campaigns.regions')),
                    items: this.regions
                },
                {
                    title: _upperFirst(this.$t('campaigns.job_profiles')),
                    items: this.profiles
                },
                {
                    title: _upperFirst(this.$t('campaigns.sector')),
                    items: this.sectors
                },
                {
                    title: _upperFirst(this.$t('campaigns.job_level')),
                    items: this.levels
                }
            ]
        },
    },
    methods: {
        fetch() {
            this.fetchEducations();
            this.fetchRegions();
            this.fetchProfiles();
            this.fetchSectors();
            this.fetchLevels();
        },
        fetchEducations() {
            return campaigns.educations(null, this.campaign.educations)
                .then(result => this.educations = result.data);
        },
        fetchRegions() {
            return campaigns.regions(null, this.campaign.regions)
                .then(result => this.regions = result.data);
        },
        fetchProfiles() {
            return campaigns.profiles(null, this.campaign.job_profiles)
                .then(result => this.profiles = result.data);
        },
        fetchSectors() {
            return campaigns.sectors(null, [this.campaign.sector])
                .then(result => this.sectors = result.data);
        },
        fetchLevels() {
            return campaigns.levels(null, [this.campaign.job_level])
                .then(result => this.levels = result.data);
        },
    },
    mounted() {
        this.fetch();
    }
}
</script>
